import React from 'react';
import profile1 from '../assets/images/SusanProfile1.jpeg';
import profile2 from '../assets/images/susanprofile2.jpeg';
import '../assets/styles/about.css';

const About = () => {
  return (
    <section className="section about" id="sobre">
      <div className="about-container">
        <div className="about-section fade-in">
          <div className="text-left">
            <h1 className="titulo-susan">Susan Oliveira</h1>
            <p>Hi, my name is Susan, but you can call me Su!</p>
            <p>Ever since I was little I've been completely passionate about three things: music, photography and cinema.</p>
            <p>Art is part of who I am. Being able to record concerts and immortalise the music in that unique moment is a gift that the universe has given me, and I love it very much.</p>
            <p>Photographing concerts is, for me, more than just capturing images. It's an extension of my own essence, a way of connecting with what is most pure and magical in art. And that's when my camera becomes an extension of who I am. I could go through the dictionary and still not find a word to define the feeling I get when I have a camera in my hand and an artist in front of me.</p>
          </div>
          <div className="image-right slide-in">
            <img 
              src={profile1} 
              alt="Susan Profile"
              loading="lazy"
            />
          </div>
        </div>

        <div className="about-section fade-in">
          <div className="text-right">
            <p>Each show is a unique experience, each artist has a universe of stories to sing about and my mission is to record them in the most beautiful and sincere way possible.</p>
            <p>Every concert is a new and magical experience. No matter the genre, the artist or the size of the event. What matters is the connection, the moment when music and image merge and create something eternal.</p>
            <p>Photographing concerts, for me, is like bringing the sound to life, eternalising the magic, the surrender and the connection between the artist and the audience. And in the end, it's this mixture of sounds, lights and emotions that makes me feel alive, as if music and photography were inherent parts of my very soul.</p>
            <p>I'm moved by music, from waking up to going to bed, music is in every moment of my day and it would be completely impossible not to include it in my work and my dreams.</p>
            <p>My work has been featured in several magazines, and I've had the privilege of working with countless clients who have trusted me to document their special moments. Whether it's a once-in-a-lifetime event or a simple family photo session, I strive to create images that are not just pictures, but memories to be cherished forever.</p>
          </div>
          <div className="image-left">
            <img 
              src={profile2} 
              alt="Susan Profile"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;